import { useRootPageLinkForm } from '@/hooks/useRootPageLinkForm';
import IRootPageLink from '@/types/IRootPageLink';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

interface IProps {
	link: IRootPageLink;
	isLoading: boolean;
	onChange: (q: IRootPageLink) => void;
	onDelete: (q: IRootPageLink) => void;
}

export function useAccordionLink(props: IProps) {
	const { t } = useTranslation();
	const { form } = useRootPageLinkForm({ link: props.link });
	const tagForm = useForm({ defaultValues: { tag: '' } });

	/**
	 * Callback executed every time something in the question is changed.
	 */
	const handleChange = form.handleSubmit((v) => {
		props.onChange(v);
	});

	function registerSubmitOnBlur(id: any, options?: any) {
		const originalValues = form.register(id, options);

		function onBlur(e: any) {
			originalValues.onBlur(e as any);
			handleChange();
		}

		return { ...originalValues, id, onBlur };
	}

	return {
		registerSubmitOnBlur,
		handleChange,
		form,
		tagForm,
		t,
	};
}
